import { writable } from 'svelte/store';
import { restorePersistedImageState } from '../utils/taskImageUtils';

function loadInitial() {
  if (typeof localStorage === 'undefined') return {
    uploadedImage: null,
    uploadedImageUrl: null,
    resultImage: null,
    resultImages: null,
    imageWidth: 0,
    imageHeight: 0,
    originalImageData: null,
    canvasData: null,
    serverImageUrl: null,
    currentTaskImageUrl: null,
    taskOriginalImageUrl: null
  };
  const saved = localStorage.getItem('erion_image_store');
  if (saved) {
    try {
      return restorePersistedImageState(JSON.parse(saved));
    } catch (e) {
      console.error('failed to parse image store', e);
    }
  }
  return {
    uploadedImage: null,
    uploadedImageUrl: null,
    resultImage: null,
    resultImages: null,
    imageWidth: 0,
    imageHeight: 0,
    originalImageData: null,
    canvasData: null,
    serverImageUrl: null,
    currentTaskImageUrl: null,
    taskOriginalImageUrl: null
  };
}

// 이미지 관련 상태를 관리하는 스토어
export const imageStore = writable(loadInitial());

export function resetImageStore() {
  imageStore.set({
    uploadedImage: null,
    uploadedImageUrl: null,
    resultImage: null,
    resultImages: null,
    imageWidth: 0,
    imageHeight: 0,
    originalImageData: null,
    canvasData: null,
    serverImageUrl: null,
    currentTaskImageUrl: null,
    taskOriginalImageUrl: null
  });
}

if (typeof localStorage !== 'undefined') {
  imageStore.subscribe(value => {
    try {
      localStorage.setItem('erion_image_store', JSON.stringify(value));
    } catch (e) {
      console.error('failed to save image store', e);
    }
  });
}
